import { ADMIN_IMAGE_ANALYSIS_API, BulkAnalysisComp } from '@aloft/toolkit-shared';

export type AnalysisResult = (typeof ADMIN_IMAGE_ANALYSIS_API.POST.RESPONSE)['_type'];

export type BulkCompResult = {
  comp: BulkAnalysisComp;
  status: 'pending' | 'success' | 'error';
  /** Parsed from AI string label e.g. "Q3" → 3 */
  aiQuality?: number;
  /** Parsed from AI string label e.g. "C2" → 2 */
  aiCondition?: number;
  errorMessage?: string;
  timingMs?: number;
  /** Full API response — available when status === 'success' */
  fullResult?: AnalysisResult;
};

/** Parse "Q3" → 3, "C2" → 2. Returns undefined for unexpected formats. */
export const parseRatingLabel = (label: string | undefined): number | undefined => {
  if (label == null || label.length < 2) return undefined;
  const n = parseInt(label.slice(1), 10);
  return Number.isFinite(n) ? n : undefined;
};
